import React, { Fragment } from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import Question from './Question';
import QuestionCount from './QuestionCount';
import AnswerOption from './AnswerOption';
import Button from '../../artzu-ui/src/Button';

const Quiz = ({
  answer,
  questionId,
  onAnswerSelected,
  onNextButtonClicked,
  onPrevButtonClicked,
  questionTotal,
  answerOptions,
  question
}) => {
  const renderAnswerOptions = key => (
    <AnswerOption
      key={key.content}
      answerContent={key.content}
      answerType={key.type}
      answer={answer}
      questionId={questionId}
      onAnswerSelected={onAnswerSelected}
    />
  );

  return (
    <Fragment>
      <div className="new-exam__body--padding" key={questionId}>
        <div className="new-exam__body__desk">
          <div className="new-exam__body__desk--mid">
            <QuestionCount counter={questionId} total={questionTotal} />
            <Question content={question} />
          </div>
          <div className="new-exam__body__desk--right">
            <ul className="new-exam__body__answerOptions">
              {answerOptions.map(renderAnswerOptions)}
            </ul>
          </div>
        </div>
      </div>
      {/* <hr className="new-exam__body__hr" /> */}
      <div className="new-exam__body__buttons mobile--footer">
        <Button
          padding="0"
          label="Previous"
          color="#414141"
          size="xl"
          onClick={onPrevButtonClicked}
          disabled={questionId === 1 ? true : false}
        />
        <Button
          padding="0"
          primary
          label="Next"
          size="xl"
          onClick={onNextButtonClicked}
          disabled={answer ? false : true}
        />
      </div>
      <div className="new-exam__body__buttons desktop--footer">
        <Button
          padding="0"
          label="Previous"
          color="#414141"
          size="xl"
          onClick={onPrevButtonClicked}
          disabled={questionId === 1 ? true : false}
        />
        <Button
          padding="0"
          primary
          label="Next"
          size="xl"
          onClick={onNextButtonClicked}
          disabled={answer ? false : true}
        />
      </div>
    </Fragment>
  );
};

export default Quiz;



// WEBPACK FOOTER //
// ./src/components/NewExam/Quiz.js